import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import utils, { FUTURE_KEYWORD, hour } from 'utils';

const DAYS_FUTURE = `day${FUTURE_KEYWORD}`;
const HOURS_FUTURE = `hour${FUTURE_KEYWORD}`;

const HOURS_IN_A_DAY = 24;
export const MIN_EXPIRATION_DAYS = 3;

const useGetExpirationDate = () => {
  const { t } = useTranslation();

  return useCallback(
    (expirationDate?: Date, numberOfDays = MIN_EXPIRATION_DAYS) => {
      if (!expirationDate) return '';

      const { isFuture, day, seconds, getCount } =
        utils.getDateVariables(expirationDate);

      if (!isFuture) return '';

      const days = getCount(day, true);

      if (seconds > numberOfDays * day)
        return `${t(DAYS_FUTURE, { count: days })}`;

      const hours = getCount(hour, true) % HOURS_IN_A_DAY;

      if (days >= 1)
        return `${t(DAYS_FUTURE, { count: days })}${
          hours ? ` ${t('and')} ${t('hour', { count: hours })}` : ''
        }`;

      if (hours >= 1) return t(HOURS_FUTURE, { count: hours });

      return t('lessThenHour');
    },
    [t],
  );
};

export default useGetExpirationDate;
